export const SET_PATIENT_CERT_HISTORY = 'CertGlobalContext.SET_PATIENT_CERT_HISTORY';